import { BrowserRouter, useLocation, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { ChatProvider } from './context/ChatContext';
import { BrandProvider } from './context/BrandContext';
import { UploadProvider } from './context/UploadContext';
import { Toaster } from './components/ui/sonner';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import EmailLogin from './pages/EmailLogin';
import TestLogin from './pages/TestLogin';
import HelpCenter from './pages/HelpCenter';
import Chat from './pages/Chat';
import AuthCallback from './pages/AuthCallback';
import Profile from './pages/Profile';
import Setup from './pages/Setup';
import './App.css';

function AppRoutes() {
  const location = useLocation();
  
  // Check URL fragment for session_id (OAuth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signin" element={<EmailLogin />} />
      <Route path="/test" element={<TestLogin />} />
      <Route path="/setup" element={<Setup />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/help" element={<HelpCenter />} />
      <Route path="/chat" element={<Chat />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <BrandProvider>
          <AuthProvider>
            <ChatProvider>
              <UploadProvider>
                <div className="App">
                  <AppRoutes />
                  <Toaster position="top-right" />
                </div>
              </UploadProvider>
            </ChatProvider>
          </AuthProvider>
        </BrandProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
